import { Permission } from "@edgetier/watchtower-types";

/**
 * Establish whether a user's permissions satisfy the permission(s) a page or element requires. This is the single
 * place the "OR by default, AND when the route says so" rule lives, so anything that needs to know whether a user can
 * reach a page decides it the same way.
 * @param requiredPermissions The permission(s) the page or element requires.
 * @param grantedPermissions  The permissions the user has.
 * @param operation           How to combine multiple required permissions. Defaults to "OR".
 * @returns True when the user's permissions satisfy the requirement.
 */
export const hasRequiredPermissions = (
    requiredPermissions: Permission | Permission[],
    grantedPermissions: Permission[],
    operation: "AND" | "OR" = "OR"
): boolean => {
    const required = Array.isArray(requiredPermissions) ? requiredPermissions : [requiredPermissions];
    return operation === "AND"
        ? required.every((value) => grantedPermissions.includes(value))
        : required.some((value) => grantedPermissions.includes(value));
};
